<script>
export default {
  name: 'CartForm',
  data() {
    return { quantity: 1 };
  },
  methods: {
    addToCart() {
      this.$store.dispatch('cart/addVariant', { variant: this.variant, quantity: this.quantity });
      this.quantity = 1;
    },
  },
  props: ['variant'],
};
</script>

<template>
  <div>
    <input v-model="quantity" type="number" min="1" class="border rounded p-1 w-10 md:w-12" />
    <a
      href="#"
      class="md:ml-1 p-1 md:p-2 bg-orange-diagomics-light hover:bg-orange-diagomics-dark text-white"
      @click.prevent="addToCart"
    >
      <i class="fas fa-plus"></i>
    </a>
  </div>
</template>
